
<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
     <h5 class="card-title border-0 pb-0">Outgoing Letter List '{{CustomerName}}'</h5>
     <br/>
     <br/>
     <div class="row">
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">Start Date</label>
        <input type="text" #datepickerInputStart placeholder="Type here..."   class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputStart"></ng-persian-datepicker>
      </div>
      <div class="form-group col-md-6">
        <label for="exampleInputEmail1">End Date</label>
        <input type="text" #datepickerInputEnd  placeholder="Type here..."  class="form-control" />
        <ng-persian-datepicker style="position: absolute;z-index: 5;" [timeEnable]="false" [dateFormat]="'jYYYY-jMM-jDD'" [input]="datepickerInputEnd"></ng-persian-datepicker>
      </div>
    </div>
     <div class="row">
      <div  class="form-group col-md-6" >
        <button *ngIf="!Procssing" type="button" (click)="GetLetterRequestCustomerSadereh(datepickerInputStart.value,datepickerInputEnd.value)" class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-search"></i> Search </button>
        <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
      </div>
     </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Letter Number</th>
              <th>Date Letter</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterRequestCustomer
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_LetterRequestCustomer).length
                      }
            ">
              <td>{{DataList_LetterRequestCustomer.indexOf(item)+1}}</td>
              <td>{{item.code}}</td>
              <td>{{item.persianDate}}</td>
              <td>
                <div class="btn-group "   role="group" aria-label="Button group with nested dropdown">
                  <div  class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        Actions
                    </button>
                    <div class="dropdown-menu"  aria-labelledby="btnGroupDrop1">
                        <a target="_blank" class="dropdown-item" href="{{BaseUrl}}{{item.id}}" ><i class="fa fa-file-pdf-o"></i> PDF </a>
                    </div>
                </div>

                <div *ngIf="item.DeletingProccess" >
                  <img  src="assets/Loading.gif" style="width: 25px;" />
                </div>
              </div>
              </td>

            </tr>
          </tbody>
        </table>
     </div>
    </div>
    <pagination-controls
     id="DataList_FeildTable"
     nextLabel="Next"
     previousLabel="Previous"
     (pageChange)="page = $event"
   ></pagination-controls>
  </div>
</div>